/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

SmoothScroll();

function checkScreenWidth() {
    const viewport = document.querySelector('meta[name="viewport"]');
    viewport.setAttribute('content', 'width=' + (screen.width <= 340 ? '340' : 'device-width, height=device-height, initial-scale=1'));
}

window.addEventListener('DOMContentLoaded', checkScreenWidth);
window.addEventListener('resize', checkScreenWidth);

Fancybox.bind('[data-fancybox]', {});

// $('#toggle_team').on('click', function () {
//     $('#collapse_team').toggleClass('open');

//     let btn = $(this);
//     let span = btn.find('span');

//     let openText = btn.data('open');
//     let closeText = btn.data('close');

//     span.text(
//         span.text() === openText ? closeText : openText
//     );
// });

let mask_phone = document.querySelector('form input[name=phone]');
window.intlTelInput(mask_phone, {
    autoPlaceholder: 'off',
    hiddenInput: mask_phone.name,
    initialCountry: 'md',
    preferredCountries: ['md', 'ro'],
    separateDialCode: true,
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
});

// var form_start = false;
// $('form .form-control').focus(function () {
//     if (form_start == false) {
//         dataLayer.push({ 'event': 'form_start' });
//         form_start = true;
//     }
// });

$('form').submit(function (e) {
    e.preventDefault();

    const btn_submit = $(this).find('button[type="submit"]');
    btn_submit.attr('disabled', true);

    // dataLayer.push({ 'event': 'form_submit' });

    const alert = (message, type) => {
        let wrapper = document.createElement('div')
        wrapper.innerHTML = [
            `<div class="alert alert-${type} alert-dismissible" role="alert">`,
            `   <div>${message}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
            '</div>'
        ].join('');

        $('.form-response').append(wrapper);
    }

    $.ajax({
        url: $(this).attr('action'),
        method: $(this).attr('method'),
        data: $(this).serialize() + '&submit=submit',
        dataType: 'json',
    }).done(function (response) {
        if (response == true) {
            alert('Mesajul a fost expediat cu succes!', 'success');
            // dataLayer.push({ 'event': 'lead_generated' });
        } else {
            alert('Eroare în procesarea formularului. Vă rugăm să încercați din nou mai târziu.', 'warning');
        }
    }).fail(function (error) {
        alert('Eroare în timpul expedierii formularului. Vă rugăm să încercați din nou.', 'danger');
    }).always(function () {
        btn_submit.attr('disabled', false);
    });

    this.reset();
});

gsap.registerPlugin(ScrollTrigger);

const element_h1 = document.querySelector('.section-1 h1');
if (element_h1) {
    ScrollTrigger.create({
        trigger: element_h1,
        start: "top 90%",
        onEnter: () => {
            element_h1.classList.remove('invisible');
            element_h1.classList.add('animate__animated', 'animate__zoomIn');
        }
    });
}

const element_h2 = document.querySelector('.section-2 h2');
if (element_h2) {
    ScrollTrigger.create({
        trigger: element_h2,
        start: "top 90%",
        onEnter: () => {
            element_h2.classList.remove('invisible');
            element_h2.classList.add('animate__animated', 'animate__fadeInUp');
        }
    });
}

const element_footer_logo = document.querySelector('footer .logo');
if (element_footer_logo) {
    ScrollTrigger.create({
        trigger: element_footer_logo,
        start: "top 90%",
        onEnter: () => {
            element_footer_logo.classList.remove('invisible');
            element_footer_logo.classList.add('animate__animated', 'animate__fadeInLeft');
        }
    });
}

const element_footer_contacts = document.querySelector('footer .contacts');
if (element_footer_contacts) {
    ScrollTrigger.create({
        trigger: element_footer_contacts,
        start: "top 90%",
        onEnter: () => {
            element_footer_contacts.classList.remove('invisible');
            element_footer_contacts.classList.add('animate__animated', 'animate__fadeInRight');
        }
    });
}

gsap.utils.toArray('.section-1 .logo, .section-2 .wrapper, .section-2 p').forEach((element) => {
    ScrollTrigger.create({
        trigger: element,
        start: "top 90%",
        onEnter: () => {
            element.classList.remove('invisible');
            element.classList.add('animate__animated', 'animate__fadeIn');
        }
    });
});

gsap.utils.toArray('.section-1 .accordion-item').forEach((element) => {
    ScrollTrigger.create({
        trigger: element,
        start: "top 90%",
        onEnter: () => {
            element.classList.remove('invisible');
            element.classList.add('animate__animated', 'animate__fadeInUp');
        }
    });
});